import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IsActiveMatchOptions, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { FuseVerticalNavigationComponent } from '@fuse/components/navigation/vertical/vertical.component';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseNavigationItem } from '@fuse/components/navigation/navigation.types';
import { FuseUtilsService } from '@fuse/services/utils/utils.service';
import { environment } from 'environments/environment';
import { ApiService } from 'app/providers/api.service';


@Component({
    selector: 'fuse-vertical-navigation-basic-item',
    templateUrl: './basic.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FuseVerticalNavigationBasicItemComponent implements OnInit, OnDestroy {
    @Input() item: FuseNavigationItem;
    @Input() name: string;
    @Input() mn_type = '';
    env_srvr_pth = environment.apiOrigin;
    
    isActiveMatchOptions: IsActiveMatchOptions;
    private _fuseVerticalNavigationComponent: FuseVerticalNavigationComponent;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    active_id: any;

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private _fuseUtilsService: FuseUtilsService,
        private apiSrvc: ApiService,
        private _router: Router
    ) {
        // Set the equivalent of {exact: false} as default for active match options.
        // We are not assigning the item.isActiveMatchOptions directly to the
        // [routerLinkActiveOptions] because if it's "undefined" initially, the router
        // will throw an error and stop working.
        this.isActiveMatchOptions = this._fuseUtilsService.subsetMatchOptions;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Set the "isActiveMatchOptions" either from item's
        // "isActiveMatchOptions" or the equivalent form of
        // item's "exactMatch" option
        this.isActiveMatchOptions =
            this.item.isActiveMatchOptions ?? this.item.exactMatch
                ? this._fuseUtilsService.exactMatchOptions
                : this._fuseUtilsService.subsetMatchOptions;

        // Get the parent navigation component
        this._fuseVerticalNavigationComponent = this._fuseNavigationService.getComponent(this.name);

        // Mark for check
        this._changeDetectorRef.markForCheck();

        // Whenever the route changes, clear any sticky forced-active highlight
        // (item.active / active_id) so the active state always follows the
        // current page via routerLinkActive instead of staying on the last
        // item the user clicked.
        this._router.events.pipe(
            filter((e) => e instanceof NavigationEnd),
            takeUntil(this._unsubscribeAll)
        ).subscribe(() => {
            this.active_id = null;
            if (this.item) {
                this.item.active = false;
            }
            this._changeDetectorRef.markForCheck();
        });

        if (this._fuseVerticalNavigationComponent)
            // Subscribe to onRefreshed on the navigation component
            this._fuseVerticalNavigationComponent.onRefreshed.pipe(
                takeUntil(this._unsubscribeAll)
            ).subscribe(() => {

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
            // console.log("MENTU ITEM ------------------------------- ", this.mn_type,this.item)
            // alert(this.mn_type)
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
    showsubmnus(){
        // console.log(this.item)
       
        if(this.item['children']?.length>1){
            this.apiSrvc.setSubMnuLst(this.item)
            this.active_id=this.item['mnu_itm_id']
            this.apiSrvc.setActMnu(this.active_id)
            
            // console.log(this.active_id)
            
        }
        else{
            // this.apiSrvc.setSubMnuLst([])
            this.active_id=null
            this.apiSrvc.setActMnu(this.active_id)
        }

    }
    resetHeader(){

        console.log(this.item, "^^^^^^^^^^^^");
        if(this.item && this.item['children'] && this.item['children'].length){
            localStorage.setItem('crnt_url_rfsh', null)
        }
        else{
            localStorage.setItem('crnt_url_rfsh', this.item['link']) 
        }
        
        // console.log(this.active_id)
        this.apiSrvc.getActMnu().subscribe((res)=>{
            // console.log(res)
            if(!res)
                {
                    this.apiSrvc.setSubMnuLst([])
                }

        })
        if(this.item['mnu_itm_id'] && this.item['prnt_mnu_itm_id'] && this.item['mnu_itm_id']==this.item['prnt_mnu_itm_id']){
            this.apiSrvc.setSubMnuLst([])
            this.active_id=null
            this.apiSrvc.setActMnu(this.active_id)
        }
        // this.apiSrvc.shwCstmHdr({ shw_hdr: false, title: '', shw_fltr: false, fltr_jsn: [] }, (clbk_res)=>{
        //     console.log("CLBK RES ------------------------ ", clbk_res)
        //   })  
        
       
    }
}
